import axios from '../../axios/index.js'

export default {
  chartData(params) {
    return axios.post('/covid/barchart', params)
  },
  sequence(params) {
    return axios.post('/covid/sequence', params)
  },
  bigpie(params) {
    return axios.post('/covid/bigpie', params)
  },
  heatmap(params) {
    return axios.post('/covid/heatmap', params)
  },
  strains() {
    return axios.get('/covid/strains')
  }
}
